<template>
  <div>
    <div v-if="workingOn">
      <h1 class="w-full my-5 bg-yellow-300 font-bold text-yellow-700 flex align-middle py-2 pl-2">
        {{ message }}
      </h1>
    </div>
    <section class="w-full flex flex-col md:flex-row justify-between mb-3" :aria-label="$t('checkout.payment-method')">
      <div class="w-full md:w-1/2 lg:w-1/2 my-10 md:my-0">
        <cart-payment-methods v-model="paymentMethod" :showCash="false" />
      </div>
    </section>
    <checkout-payments :paymentMethod="paymentMethod.slug" v-model="stripePaymentMethod" />
    <checkout-button
      v-model="workingOn"
      v-if="showCheckoutButton"
      @updatedMessage="message = $event"
      :message="message"
      :paymentMethod="paymentMethod"
      :stripePaymentMethod="stripePaymentMethod"
      :createOrder="false"
      :order="order" />
  </div>
</template>

<script>
import axios from 'axios';

import CartPaymentMethods from '@/components/cart/CartPaymentMethods.vue';
import { mapGetters } from 'vuex';
import CheckoutPayments from '../CheckoutPayments.vue';
import CheckoutButton from '../CheckoutButton.vue';

export default {
  props: ['order'],

  components: {
    CartPaymentMethods,
    CheckoutPayments,
    CheckoutButton,
  },

  data() {
    return {
      paymentMethod: this.$store.getters['cart/paymentMethod'] ? this.$store.getters['cart/paymentMethod'] : 'stripe',
      workingOn: false,
      message: '',

      stripePaymentMethod: this.order.stripe_payment_method_id,
    };
  },

  computed: {
    ...mapGetters({
      authenticated: ['auth/authenticated'],
      customer: ['auth/customer'],
    }),

    showCheckoutButton() {
      let ok = true;
      if (!this.paymentMethod.slug) {
        ok = false;
      }
      if ((this.paymentMethod.slug === 'stripe' || this.paymentMethod.slug === 'sepa')
        && (!this.stripePaymentMethod || this.stripePaymentMethod === 'last')) {
        ok = false;
      }
      return ok;
    },
  },

  watch: {
    paymentMethod() {
      this.updateOrderPaymentMethod();
    },

    stripePaymentMethod() {
      this.updateOrderPaymentMethod();
    },
  },

  methods: {
    updateOrderPaymentMethod() {
      const order = {
        payment_method: this.paymentMethod.slug,
        pth_code_payment_method: this.paymentMethod.pth_code,
      };
      if (this.paymentMethod.slug === 'stripe' || this.paymentMethod.slug === 'sepa') {
        order.stripe_payment_method_id = this.stripePaymentMethod;
      }
      axios.put(`/api/orders/${this.order.order_no}/payment-method`, order).then(() => {
        this.$emit('updated');
      }).catch((error) => {
        this.checkSessionErrorNotification(error);
      });
    },

  },
};
</script>
